<template>
  <form 
    class="sm-group-forwarding__details"
    @submit.prevent="handleSubmit"
  >
    <h5>Parcel details</h5>
    <div class="sm-group-forwarding__details-main">
      <input-text
        v-model="formData.preparerName"
        :label="'Shipping preparer name'"
        :hint="'The person who signs the international shipment.'"
        :name="'preparerName'"
        v-validate="'required'"
        data-vv-as="Shipping preparer name"
        :error="errors.first('preparerName')"
      />
      <p>If your parcel cannot be delivered please select one of the following options:</p>
      <div class="sm-group-forwarding__details-main-radio">
        <radiobutton-block 
          :text="`Return the parcel (at my expense)`" 
          :name="`onFailure`" 
          :checked="formData.onFailure == 'return'"
          @input="formData.onFailure = 'return'" 
        />
        <radiobutton-block 
          :text="`Abandon`" 
          :name="`onFailure`" 
          :checked="formData.onFailure == 'abandon'"
          @input="formData.onFailure = 'abandon'" 
        />
      </div>
      <dropdown-wrap
        v-model="selectedReason"
        :val="exportReasons[0]"
        :options="exportReasons"
        :placeholder="'Select reason for export...'"
        :label="'Reason for export'"
        @input="formData.exportReason = selectedReason.value"
      />
      <input-text
        v-if="formData.exportReason && formData.exportReason == 'other'"
        v-model="otherReason"
        :placeholder="'Specify reason...'"
        :class="'sm-group-forwarding__details-main-reason'"
        :name="'otherReason'"
        v-validate="'required'"
        data-vv-as="Reason"
        :error="errors.first('otherReason')"
      />

      <div 
        class="sm-group-forwarding__details-main-table"
        ref="table"
      >
        <table class="sm-table">
          <thead>
            <tr>
              <th class="sort sm-txt-upper">Qty.</th>
              <th class="sort sm-txt-upper hr-code">
                <div>
                  <a
                    :href="hrCodeLink" 
                    class="sm-txt-strong"
                    target="_blank"
                  >HS Code</a>
                  <hint-wrap
                    :text="hrCodeHint"
                    :left="true"
                  >
                    <template slot="content">
                      <include-svg :name="'icon-hint'" />
                    </template>
                  </hint-wrap>
                </div>
              </th>
              <th class="sort sm-txt-upper descr">Description</th>
              <th class="sort sm-txt-upper">Weight (oz)</th>
              <th class="sort sm-txt-upper">
                <div>
                  <span class="sm-txt-strong">Value</span>
                  <hint-wrap
                    :text="valueHint"
                    :left="true"
                  >
                    <template slot="content">
                      <include-svg :name="'icon-hint'" />
                    </template>
                  </hint-wrap>
                </div>
              </th>
              <th class="sort sm-txt-upper origin">Origin</th>
              <th class="sort sm-txt-upper value">Declared value</th>
            </tr>
          </thead>
          <tbody>
            <customs-item
              v-for="(item, index) in formData.customs"
              :key="`customs-item-${index}`"
              :item="item"
              @update="formData.customs[index] = $event"
            />
          </tbody>
        </table>
      </div>
      <div 
        class="sm-group-forwarding__details-main-fake-scroll"
        @scroll="scrollTable"
      >
        <div></div>
      </div>

      <span
        v-if="errors.first('customs')"
        class="sm-group-forwarding__details-main-error sm-error sm-tiny"
      >{{errors.first('customs')}}</span>

      <btn-block
        :type="'submit'"
        :text="'Find rates'"
        :class="'sm-btn--small'"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import InputText from '@/components/InputText';
import Radiobutton from '@/components/Radiobutton';
import DropdownWrap from '@/components/DropdownWrap';
import CustomsItem from '@/views/admin/pages/pages-components/mail-forwarding/CustomsItem';
import HintWrap from '@/components/HintWrap';

import ExportReasonsTemp from '@/temp/export-reasons';

export default {
  name: 'mail-forwarding-details',
  components: {
    'input-text': InputText,
    'radiobutton-block': Radiobutton,
    'dropdown-wrap': DropdownWrap,
    'customs-item': CustomsItem,
    'hint-wrap': HintWrap
  },
  data() {
    return {
      formData: {
        preparerName: '',
        exportReason: '',
        onFailure: 'return',
        customs: []
      },
      otherReason: '',
      exportReasons: [],
      selectedReason: null,
      selectedCountry: {},
      customsItemTpl: {
        description: '',
        quantity: 1,
        hrCode: '4817', // Legacy
        weight: 1,
        value: '',
        originCountry: 'US'
      },
      hrCodeLink: 'https://hts.usitc.gov/',
      hrCodeHint: 'Find the HS code in http://hts.usitc.gov',
      valueHint: 'Origin country\'s currency'
    }
  },
  computed: {
    ...mapGetters({
      countryList: 'countryList',
      provider: 'provider'
    })
  },
  created() {
    this.exportReasons = ExportReasonsTemp;
    this.formData.exportReason = this.exportReasons[0].value;
    this.formData.customs = [
      this.customsItemTpl,
      this.customsItemTpl,
      this.customsItemTpl,
      this.customsItemTpl,
    ]
  },
  methods: {
    handleSubmit() {
      this.errors.clear();

      this.$validator.validate()
        .then(valid => {
          if (!valid)
            return;

          let customsItems = this.formData.customs.filter(item => item.description && item.value && item.weight && item.hrCode);

          if (!customsItems.length) {
            this.errors.add({
              field: 'customs',
              msg: 'Please fill in at least one item (HS code, description, weight, value)'
            });
            return;
          }

          this.$emit('find-rates', {
            ...this.formData,
            customs: customsItems
          });
        });
    },
    scrollTable(e) {
      this.$refs.table.scrollLeft = e.target.scrollLeft;
    }
  },
  watch: {
    'formData.exportReason'(val) {
      this.formData.customs.forEach(item => {
        item.hrCode = val == 'documents' ? this.customsItemTpl.hrCode : '';
      });
    }
  }
}
</script>